import React from 'react';
import { render } from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { Route, Switch, HashRouter } from 'react-router-dom';
import store from './redux/store';
import { Provider } from 'react-redux';

import 'semantic-ui-css/semantic.min.css';

render(
    <Provider store={store}>
        <React.StrictMode>
            <HashRouter>
                <Switch>
                    <Route path="/" component={App} />
                </Switch>
            </HashRouter>
        </React.StrictMode>
    </Provider>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
